import React from "react";
import AppWithAuth from "./AppWithAuth";

function App() {
  return (
    <div className="App">
      <AppWithAuth />
    </div>
  );
}

export default App;
